<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="car_smartnumber"
              label="شماره هوشمند ماشین"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.car_smartnumber"
            />
            <bita-input
              type="text"
              name="priority"
              label="اولویت"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="form.priority"
            />
          </div>
          <bita-bootbutton
            class="mr-2"
            type="primary"
            title="ثبت"
            icon="fas fa-check"
            btn-width="150px"
            :isLoading="isLoading"
            @click.native="handleSubmit"
          />
        </div>
      </bita-form>
    </div>
  </bita-modal>
</template>
<script>
export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
  },
  data() {
    return {
      colWidth: "col-lg-4",
      form: {
        car_smartnumber: "",
        priority: "",
      },
    };
  },
  methods: {
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", this.form);
        }
      });
    },
    reset() {
      this.form = {
        car_smartnumber: "",
        priority: "",
      };
      this.$refs.form.reset();
    },
    onCloseModal(e) {
      this.reset();
    },
  },
};
</script>
